export { getInstanceClient } from './ioc.browser.js';
